import { DatabaseOutlined } from '@ant-design/icons-vue'

export default [
  {
    path: '/statistical',
    name: 'statistical',
    redirect: '/statistical/inspect',
    meta: { title: '统计管理', sort: 4, icon: DatabaseOutlined, isFullScreen: false, prem: true },
    children: [
      {
        path: '/statistical/inspect',
        name: 'statisticalInspect',
        component: () => import('@/views/statistical/inspect/index.vue'),
        meta: {
          title: '设备巡检',
          sort: 1,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
    ],
  },
]
